module.exports = "/_next/static/images/6c8f7ec774710e5e50b52ebaed17fbfd-woman-with-sandwich@0.5x.jpg";